import Header_1 from "./Header/Header_1/header_1";
import Home_1 from "./Home/Home_1/home_1";
import Section_1 from "./Section/Section_1/section_1";
import Section_2 from "./Section/Section_2/section_2";
import Section_3 from "./Section/Section_3/section_3";
import Section_4 from "./Section/Section_4/section_4";
import Section_5 from "./Section/Section_5/section_5";
import Section_6 from "./Section/Section_6/section_6";
import Footer_1 from "./Footer/Footer_1/footer_1";

export const component_list = {
  Header_1,
  Home_1,
  Section_1,
  Section_2,
  Section_3,
  Section_4,
  Section_5,
  Section_6,
  Footer_1,
};
